// source: imports/ecom/currency_code.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

goog.exportSymbol(
    'proto.com.chegg.rio.backend.ecom.CurrencyCode', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.backend.ecom.CurrencyCode = {
  UNKNOWN_CURRENCY: 0,
  AED: 1,
  AFN: 2,
  ALL: 3,
  AMD: 4,
  ANG: 5,
  AOA: 6,
  ARS: 7,
  AUD: 8,
  AWG: 9,
  AZN: 10,
  BAM: 11,
  BBD: 12,
  BDT: 13,
  BGN: 14,
  BHD: 15,
  BIF: 16,
  BMD: 17,
  BND: 18,
  BOB: 19,
  BOV: 20,
  BRL: 21,
  BSD: 22,
  BTN: 23,
  BWP: 24,
  BYR: 25,
  BZD: 26,
  CAD: 27,
  CDF: 28,
  CHE: 29,
  CHF: 30,
  CHW: 31,
  CLF: 32,
  CLP: 33,
  CNY: 34,
  COP: 35,
  COU: 36,
  CRC: 37,
  CUC: 38,
  CUP: 39,
  CVE: 40,
  CZK: 41,
  DJF: 42,
  DKK: 43,
  DOP: 44,
  DZD: 45,
  EGP: 46,
  ERN: 47,
  ETB: 48,
  EUR: 49,
  FJD: 50,
  FKP: 51,
  ZWL: 52,
  GBP: 53,
  GEL: 54,
  GHS: 55,
  GIP: 56,
  GMD: 57,
  GNF: 58,
  GTQ: 59,
  GYD: 60,
  HKD: 61,
  HNL: 62,
  HRK: 63,
  HTG: 64,
  HUF: 65,
  IDR: 66,
  ILS: 67,
  INR: 68,
  IQD: 69,
  IRR: 70,
  ISK: 71,
  JMD: 72,
  JOD: 73,
  JPY: 74,
  KES: 75,
  KGS: 76,
  KHR: 77,
  KMF: 78,
  KPW: 79,
  KRW: 80,
  KWD: 81,
  KYD: 82,
  KZT: 83,
  LAK: 84,
  LBP: 85,
  LKR: 86,
  LRD: 87,
  LSL: 88,
  LYD: 89,
  MAD: 90,
  ZMW: 91,
  MDL: 92,
  MGA: 93,
  MKD: 94,
  MMK: 95,
  MNT: 96,
  MOP: 97,
  MRU: 98,
  MUR: 99,
  MVR: 100,
  MWK: 101,
  MXN: 102,
  MXV: 103,
  MYR: 104,
  MZN: 105,
  NAD: 106,
  NGN: 107,
  NIO: 108,
  NOK: 109,
  NPR: 110,
  NZD: 111,
  OMR: 112,
  PAB: 113,
  PEN: 114,
  PGK: 115,
  PHP: 116,
  PKR: 117,
  PLN: 118,
  PYG: 119,
  QAR: 120,
  RON: 121,
  RSD: 122,
  RUB: 123,
  RWF: 124,
  SAR: 125,
  SBD: 126,
  SCR: 127,
  SDG: 128,
  SEK: 129,
  SGD: 130,
  SHP: 131,
  SLL: 132,
  SOS: 133,
  SRD: 134,
  SSP: 135,
  STN: 136,
  SVC: 137,
  SYP: 138,
  SZL: 139,
  THB: 140,
  TJS: 141,
  TMT: 142,
  TND: 143,
  TOP: 144,
  TRY: 145,
  TTD: 146,
  TWD: 147,
  TZS: 148,
  UAH: 149,
  UGX: 150,
  USD: 151,
  USN: 152,
  UYI: 153,
  UYU: 154,
  UZS: 155,
  VEF: 156,
  VND: 157,
  VUV: 158,
  WST: 159,
  XAF: 160,
  XCD: 161,
  XDR: 162,
  XOF: 163,
  XPF: 164,
  XSU: 165,
  XUA: 166,
  YER: 167,
  ZAR: 168
};

goog.object.extend(exports, proto.com.chegg.rio.backend.ecom);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/ecom/currency_code_pb.js
// module id = 652
// module chunks = 11